import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosAlphaTransporte = {
    ...dadosAgenciaComum,
    id: 'alphatransporte',
    nome: 'Alpha Transporte',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
